import React from 'react';
import { View } from '@amzn/atoz-web/View';
import { MessageBanner, MessageBannerType } from '@amzn/atoz-web/MessageBanner';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { BannerTypes } from './BannerListTypes';
function mapBannerType(type) {
    switch (type) {
        case BannerTypes.Informational:
            return MessageBannerType.Informational;
        case BannerTypes.Warning:
            return MessageBannerType.Warning;
        case BannerTypes.Success:
            return MessageBannerType.Success;
        case BannerTypes.Error:
            return MessageBannerType.Error;
        case BannerTypes.Bias:
            return MessageBannerType.Bias;
        default:
            return MessageBannerType.Informational;
    }
}
export var BannerList = function (_a) {
    var bannerList = _a.bannerList;
    if (bannerList.length === 0) {
        return null;
    }
    return (React.createElement(StyledView, { dataTestId: "BannerList" }, bannerList.map(function (bannerInfo) { return (React.createElement(MessageBanner, { key: bannerInfo.listKey, type: mapBannerType(bannerInfo.type), dataTestId: bannerInfo.testId }, bannerInfo.text)); })));
};
var StyledView = styledWithTheme(View)(function (_a) {
    var theme = _a.theme;
    return "\n    & > div:not(:last-of-type) {\n        margin-bottom: ".concat(theme.selectors.space('S300'), "px;\n    }\n");
});
